<div mat-dialog-actions class="navigation-action mat-typography">
    <div class="back-and-unit-type-container">
        <button id="back-button" mat-button class="back-button" (click)="handleApply()" tabindex="-1">
            <mat-icon id="back-icon" class="back-icon">chevron_left</mat-icon>
        </button>
        <h1 id="unit-type-name-title">{{ unitTypeName }}</h1>
    </div>
    <rx-bridge-range-selector *ngIf="isBridge" [isReadOnly]="isReadOnly"></rx-bridge-range-selector>
</div>
